import React, { Suspense } from "react";
import { PropTypes } from "prop-types";
import { renderRoutes } from "react-router-config";
import { makeStyles } from "@material-ui/core/styles";
import { LinearProgress } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    "@media all and (-ms-high-contrast:none)": {
      height: 0, // IE11 fix
    },
  },
  content: {
    flexGrow: 1,
    maxWidth: "100%",
    overflowY: "hidden",
  },
}));

function LoginLayout({ route }) {
  const classes = useStyles();
  return (
    <>
      <div className={classes.container}>
        <div className={classes.content}>
          <Suspense fallback={<LinearProgress />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </div>
      </div>
    </>
  );
}

LoginLayout.propTypes = {
  route: PropTypes.object,
};

export default LoginLayout;
